import React from "react";

const Pagination = ({
  page,
  totalPages,
  loading,
  onPrev,
  onNext,
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center items-center space-x-4 pt-4">
      <button
        onClick={onPrev}
        disabled={page === 1 || loading}
        className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
          page === 1 || loading
            ? "bg-gray-700 text-gray-500 cursor-not-allowed"
            : "bg-accent-grad text-gray-900 dark:text-white hover:opacity-90 shadow-lg hover:shadow-xl transform hover:scale-105"
        }`}
      >
        &larr; Артқа
      </button>

      <div className="px-4 py-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
        <span className="text-gray-500 dark:text-gray-300 font-semibold">
          {page} / {totalPages}
        </span>
      </div>

      <button
        onClick={onNext}
        disabled={page >= totalPages || loading}
        className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
          page >= totalPages || loading
            ? "bg-gray-700 text-gray-500 cursor-not-allowed"
            : "bg-accent-grad text-gray-900 dark:text-white hover:opacity-90 shadow-lg hover:shadow-xl transform hover:scale-105"
        }`}
      >
        Алға &rarr;
      </button>
    </div>
  );
};

export default Pagination;